import { atom } from 'recoil';

// چک کردن معتبر بودن توکن و یوزر
const getInitialAuthState = () => {
  const token = localStorage.getItem('access');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    // پاک کردن داده‌های ناقص
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user');
    return { isLoggedIn: false, userInfo: null };
  }
  
  try {
    const user = JSON.parse(userStr);
    if (!user || !user.role) {
      localStorage.removeItem('access');
      localStorage.removeItem('refresh');
      localStorage.removeItem('user');
      return { isLoggedIn: false, userInfo: null };
    }
    return { isLoggedIn: true, userInfo: user };
  } catch {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user');
    return { isLoggedIn: false, userInfo: null };
  }
};

const initialAuth = getInitialAuthState();

// وضعیت لاگین
export const loggedInState = atom({
  key: 'loggedInState',
  default: initialAuth.isLoggedIn,
});

// اطلاعات کاربر
export const userInfoState = atom({
  key: 'userInfoState',
  default: initialAuth.userInfo,
});

// وضعیت لودینگ
export const loadingState = atom({
  key: 'loadingState',
  default: false,
});

// وضعیت sidebar
export const sidebarOpenState = atom({
  key: 'sidebarOpenState',
  default: true,
});